<div>
  <span matDialogTitle>{{data.title}}</span>
  <div class="body">
    <span class="warning">WARNING: </span>
    <span>{{data.warning}}</span>
    <p>{{data.description}}@if (data.helpCenterLink) {
      <a href="{{data.helpCenterLink}}" target="_blank"> Help Center article</a>
    }</p>
  </div>
  <div class="flex justify-flex-end gap-20">
    <button mat-raised-button (click)="data.onCancel()" color="default">{{deviceService.isMobile() || deviceService.isTablet() ? 'CANCEL' : 'CANCEL IMPORT'}}</button>
    <button mat-raised-button (click)="data.onContinue()" color="primary">{{deviceService.isMobile() || deviceService.isTablet() ? 'CONTINUE' : 'CONTINUE WITH IMPORT'}}</button>
  </div>
</div>
